import { DataInstance } from "./data-instance";
import { JmApi } from "../jm-api/jm-api";

export class Company extends DataInstance {
  public static BASE_URL: string =
    import.meta.env.VITE_CLEVERREACH_API_BASE_URL + "/jmapi/v1/companies";

  private data: { name: string | undefined } = { name: undefined };

  private projectId: number;

  constructor(name: string | undefined, projectId: number) {
    super();
    this.data["name"] = name;
    this.projectId = projectId;
  }

  get currentData(): object {
    return this.data;
  }

  get currentId(): number | undefined {
    return this.id;
  }

  set currentId(id: number | undefined) {
    this.id = id;
  }

  get currentProjectId(): number {
    return this.projectId;
  }

  set currentProjectId(id: number) {
    this.projectId = id;
  }

  async post(chain: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      const toInsert: object = { ...this.data, project_id: this.projectId };
      JmApi.post(Company.postUrlBuilder(this.projectId), toInsert).then(
        (data) => {
          if (chain) {
            resolve("Unternehmen erfolgreich hinzugefügt");
          }
        },
      );
    });
  }

  static postUrlBuilder(projectId: number): string {
    return `${Company.BASE_URL}?ProjId=${projectId}`;
  }

  static deleteUrlBuilder(companyId: number): string {
    return `${Company.BASE_URL}?CompanyId=${companyId}`;
  }

  static fromObject(o: object): Company | null {
    if (o["name"] && o["project_id"]) {
      const result = new Company(o["name"], o["project_id"]);
      if (!o["id"]) {
        return result;
      } else {
        result.id = o["id"];
        return result;
      }
    } else {
      return null;
    }
  }

  static getUrlBuilder(projectId: number | undefined = undefined): string {
    if (projectId) {
      return `${Company.BASE_URL}?projId=${projectId}`;
    } else {
      return Company.BASE_URL;
    }
  }

  static putUrlBuilder(companyId: number): string {
    return `${Company.BASE_URL}?CompanyId=${companyId}`;
  }

  async put(chain: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!this.id) {
        if (chain) {
          reject(`Company ID not given on company: ${this}`);
        } else {
          throw new Error(`Company ID not given on ${this}`);
        }
      } else {
        let toInsert: object = {};
        if (this.projectId) {
          toInsert = { project_id: this.projectId };
        }
        if (this.data.name) {
          toInsert["name"] = this.data.name;
        }
        JmApi.put(Company.putUrlBuilder(this.id), toInsert)
          .then((data) => {
            if (chain) {
              resolve("Firma erfolgreich bearbeitet");
            }
          })
          .catch((data) => {
            if (chain) reject(data);
          });
      }
    });
  }
}
